import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=dad3ae9e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=dad3ae9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad3ae9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dad3ae9e')) {
      api.createRecord('dad3ae9e', component.options)
    } else {
      api.reload('dad3ae9e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=dad3ae9e&scoped=true&", function () {
      api.rerender('dad3ae9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GX7t4fEGPVG4/JS/comp/DocBox.vue"
export default component.exports